<template>
  <div v-if="company">
    <send-code-form
      :is-active.sync="isSendingCode"
      :company="company"
      @changed="verificationCodeSent"
    />
    <v-card v-if="company" tile>
      <v-toolbar color="grey lighten-4" light tile flat>
        <v-toolbar-title centered class="headline font-weight-bold">
          Company Details
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-btn
          color="primary"
          class="mr-3"
          v-if="company.owner_verified_at == null && !company.is_verified"
          @click="isSendingCode = true"
          :disabled="company.owner_verified_at !== null"
        >
          <v-icon color="light-blue lighten-4">mdi-alert-circle-check</v-icon>
          Get Owner's Consent
        </v-btn>

        <v-btn
          color="primary"
          class="mr-3"
          v-if="company.owner_verified_at == null && !company.is_verified"
          @click="resendVerificationCode"
          :disabled="company.owner_verified_at !== null"
        >
          <v-icon color="light-blue lighten-4">mdi-alert-circle-check</v-icon>
          Resend Owner's Concent Code
        </v-btn>
        <div class="mr-4 d-flex justify-between">
          <v-btn color="primary" @click="isAdding = true" v-if="company.is_verified">
            offers
            <v-icon class="ml-2" color="light-blue lighten-4"> mdi-account-money</v-icon>
          </v-btn>
        </div>

        <company-menu
          :company.sync="company"
          @update:company="$emit('update:datacompany', $event)"
          v-if="!hideActions"
        />
      </v-toolbar>

      <v-card-text>
        <v-row>
          <v-col cols="4">
            <key-value title="Company Name" :value="company.name" />
            <key-value title="Unique Id">
              {{ company.id }}
            </key-value>
            <key-value title="Company Id" :value="company.registered_id" />
            <key-value title="Country" :value="company.country" />
          </v-col>
          <v-col cols="4">
            <key-value title="Address" :value="company.location" />
            <key-value title="Balance" :value="extractDataKey(company.owner, 'token_balance')" />
            <key-value
              title="Commission"
              :value="extractDataKey(company.owner, 'commission_collected')"
            />
            <key-value
              title="Verification Type"
              :value="extractDataKey(company, 'verification_type')"
            />
            <key-value
              title="Has Owners Consent"
              :value="extractDataKey(company, 'has_owner_consent').toString()"
            />
          </v-col>
          <v-col cols="4">
            <key-value title="Activation Status" :value="company.is_active.toString()" />
            <key-value title="Rejection Status" :value="company.is_rejected.toString()" />
            <key-value title="Verification Result" :value="company.verification_result" />
            <key-value title="Verification Status">
              <h3 class="success--text" v-if="company.verified_at">VERIFIED</h3>
              <h3 class="red--text" v-else-if="company.kyb_rejected_at">REJECTED</h3>
              <h3 class="warning--text" v-else>PENDING</h3>
            </key-value>
            <key-value title="Activity status">
              <v-icon color="success" size="25" v-if="company.is_active">mdi-progress-check</v-icon>
              <v-icon color="red" size="25" v-else-if="company.kyb_rejected_at">mdi-close-circle-outline</v-icon>
              <v-icon color="warning" size="25" v-else>mdi-progress-alert</v-icon>
            </key-value>
          </v-col>
          <v-col cols="4" v-if="company.associated_offers">
            <h2>Company Offers</h2>
            <div v-for="associatedoffer in company.associated_offers" :key="associatedoffer.id">
              <div class="d-flex align-items-center mt-4">
                <key-value :value="associatedoffer.offer.name" />
                <v-btn
                  small
                  color="danger"
                  icon
                  class="align-items-center text-danger"
                  @click="deleteThisOffer(associatedoffer)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <company-offer :is-active.sync="isAdding" :company.sync="company" @changed="offerAdded" />
  </div>
</template>
<script>
import CompanyOffer from "../companyOffer.vue";
import sendCodeForm from "../sendCodeForm";
import CompanyMenu from "../companyMenu";

export default {
  props: { company: Object, hideActions: { type: Boolean, default: false } },
  data: () => ({ isAdding: false, isActivating: false, isSendingCode: false }),
  components: { CompanyOffer, sendCodeForm, CompanyMenu },
  methods: {
    verificationCodeSent({ message }) {
      this.isSendingCode = false;
      Notify.success(message);
      this.$emit("reloadCompany");
    },
    async resendVerificationCode() {
      const id = this.company.id;
      await Notify.confirm(`Do you want to re-request for owner's consent Code?`).then(() => {
        this.$http
          .post(`/api/v1/companies/${id}/resendCode`)
          .then((result) => {
            Notify.success(result.message);
            this.$emit("reloadCompany");
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error) => {
            Notify.error(error.message);
          });
      });
    },
    offerAdded() {
      this.$emit("syncOffer");
      this.isAdding = false;
    },
    async deleteThisOffer(offer) {
      const id = offer.id;
      await Notify.confirm(`Do you want to detach this Offer?`).then(() => {
        this.$http
          .delete(`/api/v1/userOffer/${id}/detach`)
          .then((result) => {
            Notify.success(result.message);
            this.$emit("syncOffer");
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error) => {
            Notify.error(error.message);
          });
      });
    },
    toggleActivity() {
      this.isActivating = true;
      const { id } = this.company;
      this.$http
        .put(`api/v1/companies/${id}/activity`)
        .then((company) => {
          this.$emit("update:company", Object.assign({}, this.company, company));
          Notify.success("Operation successful");
        })
        .catch(this.showResponseError)
        .finally(() => (this.isActivating = false));
    },
  },
};
</script>
